<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        :class="['spin', {
            'w-5': props.size === 'lg',
            'w-4': props.size === 'md',
            'w-3': props.size === 'sm' || props.size === 'xs',
        }]"
    >
        <path d="M12.8797 2.53634C13.8598 2.91449 14.7559 3.48199 15.5167 4.20645C16.2776 4.93091 16.8883 5.79813 17.314 6.75859C17.7396 7.71906 17.972 8.75397 17.9977 9.80423C18.0234 10.8545 17.842 11.8995 17.4639 12.8797C17.0857 13.8599 16.5182 14.7559 15.7938 15.5168C15.0693 16.2776 14.2021 16.8883 13.2416 17.314C12.2812 17.7397 11.2462 17.972 10.196 17.9977C9.14572 18.0234 8.10068 17.8421 7.12052 17.4639C6.14036 17.0858 5.24428 16.5182 4.48345 15.7938C3.72261 15.0693 3.11192 14.2021 2.68624 13.2416C2.26055 12.2812 2.02822 11.2463 2.00249 10.196C1.97677 9.14575 2.15816 8.1007 2.53631 7.12055C2.91446 6.14039 3.48197 5.24431 4.20642 4.48347C4.93088 3.72264 5.7981 3.11195 6.75857 2.68626C7.71904 2.26058 8.75395 2.02824 9.80421 2.00252C10.8545 1.97679 11.8995 2.15819 12.8797 2.53634L12.8797 2.53634Z" stroke="#D7DAE0" stroke-opacity="0.2" style="stroke:#D7DAE0;stroke:color(display-p3 0.8431 0.8549 0.8784);stroke-opacity:0.2;" stroke-width="2.66667" />
        <path d="M12.8797 2.53634C13.8598 2.91449 14.7559 3.48199 15.5167 4.20645C16.2776 4.93091 16.8883 5.79813 17.314 6.75859C17.7396 7.71906 17.972 8.75397 17.9977 9.80423C18.0234 10.8545 17.842 11.8995 17.4639 12.8797C17.0857 13.8599 16.5182 14.7559 15.7938 15.5168C15.0693 16.2776 14.2021 16.8883 13.2416 17.314C12.2812 17.7397 11.2462 17.972 10.196 17.9977C9.14572 18.0234 8.10068 17.8421 7.12052 17.4639" stroke="#BBDAFF" style="stroke:#BBDAFF;stroke:color(display-p3 0.7333 0.8549 1.0000);stroke-opacity:1;" stroke-width="2.66667" stroke-linecap="round" />
    </svg>
</template>

<script setup lang="ts">

type Props = {
    size?: 'sm' | 'md' | 'lg' | 'xs' | null
}

const props = withDefaults(defineProps<Props>(), {
    size: 'md',
})

</script>

<style scoped>
.spin {
    animation: spin 0.8s linear infinite;
}
</style>
